// Temporal API based date utilities to replace moment.js

export function normalizeToFullYear(year: string | null): number {
  const yearNum = Number(year);
  return yearNum < 50 ? 2000 + yearNum : yearNum < 100 ? 1900 + yearNum : yearNum;
}

export const slug = (value: string): string => {
  if (!value) {
    return '';
  }
  return value.toLowerCase().replace(/ /g, '-');
};

// Deprecated
export const formatCurrency = (value: string | number) => {
  if (typeof value === 'number') {
    value = value.toString();
  } else if (!value) {
    value = '';
  }
  const hasCents = value.split('.').length > 1;
  let cents = '';
  if (hasCents) {
    const splitValue = value.split('.');
    cents = splitValue[1];
    value = splitValue[0];
  }
  const chars = value.split('').reverse();
  const withCommas = [];
  for (let i = 1, l = chars.length; i <= l; i += 1) {
    withCommas.push(chars[i - 1]);
    if (i % 3 === 0 && i !== chars.length) {
      withCommas.push(',');
    }
  }
  return `${withCommas.reverse().join('')}${hasCents ? `.${cents}` : ''}`;
};

export const getDateRangeInFullFormat = (startDateMs?: number, endDateMs?: number): string => {
  if (!startDateMs || !endDateMs) {
    return '';
  }

  try {
    const startDate = new Date(startDateMs);
    const endDate = new Date(endDateMs);

    // Check if dates are valid
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return '';
    }

    const formatDate = startDate.toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    });

    const startTimeFormatted = startDate
      .toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      .toLowerCase();

    const endTimeFormatted = endDate
      .toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      .toLowerCase();

    const formatTime = `${startTimeFormatted} - ${endTimeFormatted}`;

    // Get timezone offset in format +HH:MM or -HH:MM
    const offsetMinutes = startDate.getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const offsetMins = Math.abs(offsetMinutes) % 60;
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const formatTz = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`;

    return `${formatTime} (GMT${formatTz}) on ${formatDate}`;
  } catch {
    return '';
  }
};
